import React, { Component } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { DFPSlotsProvider, DFPManager, AdSlot } from 'react-dfp';
import { withRouter } from 'react-router-dom';

class AdBanner extends Component {
  constructor() {
    super();

    this.state = {
      isEmpty: true
    };
  }

  componentDidMount() {
    DFPManager.load();
  }

  onSlotRender(e) {
    this.setState({isEmpty: e.event.isEmpty});
    //if(e.event.isEmpty) DFPManager.refresh();
  }

  render() {
    const {
      adUnit,
      type
    } = this.props;

    const adUnitChecked = (typeof adUnit !== 'undefined') ? adUnit : '728x90_leaderboard_zone3';
    let classes = 'Ad';

    switch (type) {
      case 'header':
        classes = classnames(classes, 'Ad--header');
        break;
      case 'simple':
        classes = classnames(classes, 'Ad--no-background');
        break;
      default:
        break;
    }

    // const desktopSizes = [[728, 90]];
    const sizes = (adUnitChecked === '728x90_leaderboard_zone3') ? [[970, 90], [728, 90], [320, 50]] : [[728, 90], [320, 50]];
    const sizeMapping = (adUnitChecked === '728x90_leaderboard_zone3') ?
      [{viewport: [1024, 1], sizes:[[970, 90], [728, 90]]}, {viewport: [0, 0], sizes:[[320, 50]]}] :
      [{viewport: [1024, 1], sizes:[[728, 90]]}, {viewport: [0, 0], sizes:[[320, 50]]}]
  
    return (
      <div className={classes}>
        <DFPSlotsProvider
          dfpNetworkId={'40692871'}
          collapseEmptyDivs={true}
          autoLoad={false}
        >
          <AdSlot 
            adUnit={adUnitChecked} 
            sizes={sizes} 
            sizeMapping={sizeMapping}
            onSlotRender={(e) => this.onSlotRender(e)} 
            //shouldRefresh={ () => this.state.isEmpty }
          />
        </DFPSlotsProvider>
      </div>
    );
  }
}

AdBanner.propTypes = {
  adUnit: PropTypes.string,
  type: PropTypes.string
}

export default withRouter(AdBanner);



// WEBPACK FOOTER //
// ./src/components/ad-banner/zone3/index.js